import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/alexandergolovnya/projects/2303www/layouts/default.vue"))
}